import { Box, useTheme } from "@mui/material";
import { Track } from "../../../interfaces/dtos/track";
import { getCountryCodeForFlag } from "../../../utils/commonUtils";
import ReactCountryFlag from "react-country-flag";

interface TrackListChangeStatusConfirmationItemProps {
    track: Track;
}

export const TrackListChangeStatusConfirmationItem = ({
    track
}: TrackListChangeStatusConfirmationItemProps) => {

    const theme = useTheme();

    const countryCode = track.countryCode ? getCountryCodeForFlag(track.countryCode) : undefined;

    return (
        <Box sx={{ display: 'flex' }}>
            <Box sx={{ width: '30px', color: theme.palette.action.active }}>{track.categoryCode}</Box>
            <Box sx={{ width: '30px' }}>
                {countryCode &&
                    <ReactCountryFlag
                        countryCode={countryCode} svg
                        style={{ fontSize: '20px', marginTop: '-4px' }}
                    />
                }
            </Box>
            <Box sx={{ width: '30px' }}>{track.sportCode}</Box>
            <Box>
                {track.shortDescription}
                <span style={{ color: theme.palette.action.disabled }}> ({track.provider})</span>
            </Box>
        </Box>
    )
}
